import React from 'react';
import { Overview } from '@/types';

interface OverviewTabProps {
    overview: Overview | null;
    isDark: boolean;
}

const OverviewTab: React.FC<OverviewTabProps> = ({ overview, isDark }) => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {/* Total Users Card */}
        <div className={`bg-gradient-to-br ${isDark ? 'from-blue-900/20 to-blue-800/20' : 'from-blue-50 to-blue-100'} rounded-2xl p-6 border ${isDark ? 'border-gray-700/50' : 'border-gray-200/50'} shadow-xl transform hover:scale-105 transition-all duration-300`}>
            <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl flex items-center justify-center text-white text-xl">
                    👥
                </div>
                <div className="text-right">
                    <div className="text-3xl font-bold cgm-text-primary">{overview?.users?.total || 0}</div>
                    <div className="text-sm cgm-text-secondary font-medium">Total Users</div>
                </div>
            </div>
        </div>

        {/* Total Teams Card */}
        <div className={`bg-gradient-to-br ${isDark ? 'from-emerald-900/20 to-emerald-800/20' : 'from-emerald-50 to-emerald-100'} rounded-2xl p-6 border ${isDark ? 'border-gray-700/50' : 'border-gray-200/50'} shadow-xl transform hover:scale-105 transition-all duration-300`}>
            <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-xl flex items-center justify-center text-white text-xl">
                    🏆
                </div>
                <div className="text-right">
                    <div className="text-3xl font-bold cgm-text-primary">{overview?.teams?.total || 0}</div>
                    <div className="text-sm cgm-text-secondary font-medium">Total Teams</div>
                </div>
            </div>
        </div>

        {/* Total Organizations Card */}
        <div className={`bg-gradient-to-br ${isDark ? 'from-purple-900/20 to-purple-800/20' : 'from-purple-50 to-purple-100'} rounded-2xl p-6 border ${isDark ? 'border-gray-700/50' : 'border-gray-200/50'} shadow-xl transform hover:scale-105 transition-all duration-300`}>
            <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-purple-600 rounded-xl flex items-center justify-center text-white text-xl">
                    🏢
                </div>
                <div className="text-right">
                    <div className="text-3xl font-bold cgm-text-primary">{overview?.organizations?.total || 0}</div>
                    <div className="text-sm cgm-text-secondary font-medium">Organizations</div>
                </div>
            </div>
        </div>

        {/* Connected Devices Card */}
        <div className={`bg-gradient-to-br ${isDark ? 'from-amber-900/20 to-orange-800/20' : 'from-amber-50 to-orange-100'} rounded-2xl p-6 border ${isDark ? 'border-gray-700/50' : 'border-gray-200/50'} shadow-xl transform hover:scale-105 transition-all duration-300`}>
            <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-amber-500 to-orange-500 rounded-xl flex items-center justify-center text-white text-xl">
                    ⌚
                </div>
                <div className="text-right">
                    <div className="text-3xl font-bold cgm-text-primary">{overview?.users?.whoop_connected || 0}</div>
                    <div className="text-sm cgm-text-secondary font-medium">Connected Devices</div>
                </div>
            </div>
        </div>
    </div>
);

export default OverviewTab; 